module.exports = __webpack_public_path__ + "img/top_news_icon.04004ef6.svg";